import { render, staticRenderFns } from "./StorageDetails.vue?vue&type=template&id=d6444e8a"
import script from "./StorageDetails.vue?vue&type=script&lang=js"
export * from "./StorageDetails.vue?vue&type=script&lang=js"
import style0 from "./StorageDetails.vue?vue&type=style&index=0&id=d6444e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports